import { computed, Injectable, signal } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { JwtPayload, ModuloAcesso } from '../models/jwt.model';

@Injectable({ providedIn: 'root' })
export class TokenService {
    private tokenAcesso = signal<string | null>(localStorage.getItem('tokenAcesso'));

    payload = computed<JwtPayload | null>(() => {
        const token = this.tokenAcesso();
        if (!token) return null;

        try {
            return jwtDecode<JwtPayload>(token);
        } catch {
            return null;
        }
    });

    buscarToken() {
        return this.tokenAcesso();
    }

    definirSessao(tokenAcesso: string) {
        this.tokenAcesso.set(tokenAcesso);
        localStorage.setItem('tokenAcesso', tokenAcesso);
    }

    limparSessao() {
        this.tokenAcesso.set(null);
        localStorage.removeItem('tokenAcesso');
    }

    estaLogado(): boolean {
        return !!this.tokenAcesso();
    }

    obterId(): string | null {
        return this.payload()?.sub ?? null;
    }

    obterEmail(): string | null {
        return this.payload()?.email ?? null;
    }

    obterHubRole(): string | null {
        return this.payload()?.hub_role ?? null;
    }

    obterModulos(): ModuloAcesso[] {
        return this.payload()?.modules ?? [];
    }

    tokenExpirado(): boolean {
        const exp = this.payload()?.exp;
        if (!exp) return false;
        return Date.now() >= exp * 1000;
    }

    estaLogadoValido(): boolean {
        return this.estaLogado() && !this.tokenExpirado();
    }
}
